import React from "react";
import { SectionLabel } from "./ui";

const ROWS = [
  { k: "Self-learning from outcomes",       ekkbaz: true,  generic: false,    inhouse: "Sometimes", consult: false },
  { k: "Custom to your data + workflows",   ekkbaz: true,  generic: false,    inhouse: true,        consult: true },
  { k: "Acts on your systems (200+ tools)", ekkbaz: true,  generic: "Limited",inhouse: "Limited",   consult: false },
  { k: "Live in 6 weeks",                   ekkbaz: true,  generic: true,     inhouse: false,       consult: false },
  { k: "Outcome-linked pricing",            ekkbaz: true,  generic: false,    inhouse: false,       consult: false },
  { k: "Audit trail + governance",          ekkbaz: true,  generic: false,    inhouse: "DIY",       consult: "DIY" },
  { k: "Compounds across functions",        ekkbaz: true,  generic: false,    inhouse: false,       consult: false },
  { k: "Total Y1 cost (ballpark)",          ekkbaz: "$24K–$140K", generic: "$60K + your team", inhouse: "$1.2M+", consult: "$800K+" },
];

const COLS = ["EkkBaz AI", "Generic LLM tools", "Build in-house", "Big-4 consultants"];

const renderCell = (v, hi = false) => {
  if (v === true) return <span className={`inline-flex items-center gap-2 ${hi ? "text-cyan-200" : "text-emerald-200"}`}><span className="h-1.5 w-1.5 rounded-full bg-current" />Yes</span>;
  if (v === false) return <span className="text-white/30">—</span>;
  return <span className={hi ? "text-cyan-200" : "text-white/70"}>{v}</span>;
};

export default function ComparisonSection() {
  const cell = "px-4 py-3 text-[13px] border-t border-white/[0.06]";
  return (
    <section className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <SectionLabel>The honest comparison</SectionLabel>
          <h2 className="mt-5 text-[36px] leading-[1.05] tracking-tight sm:text-[44px] lg:text-[52px]">
            <span className="text-white">Why teams pick EkkBaz</span>{" "}
            <span className="font-display italic grad-text">over the alternatives.</span>
          </h2>
        </div>
        <div className="mt-12 overflow-hidden rounded-2xl border border-white/[0.08] bg-[#070d24]">
          <div className="grid grid-cols-[1.6fr,1fr,1fr,1fr,1fr] items-stretch">
            <div className="px-4 py-4 font-mono text-[10.5px] uppercase tracking-[0.22em] text-white/40">capability</div>
            {COLS.map((c, i) => (
              <div key={c} className={`px-4 py-4 text-[13px] font-semibold ${i === 0 ? "bg-cyan-300/[0.05] text-cyan-200 border-l border-cyan-300/15" : "text-white/85 border-l border-white/[0.06]"}`}>
                {c}
              </div>
            ))}
            {ROWS.map(r => (
              <React.Fragment key={r.k}>
                <div className={`${cell} text-white/80`}>{r.k}</div>
                <div className={`${cell} bg-cyan-300/[0.04] border-l border-cyan-300/15`}>{renderCell(r.ekkbaz, true)}</div>
                <div className={`${cell} border-l border-white/[0.06]`}>{renderCell(r.generic)}</div>
                <div className={`${cell} border-l border-white/[0.06]`}>{renderCell(r.inhouse)}</div>
                <div className={`${cell} border-l border-white/[0.06]`}>{renderCell(r.consult)}</div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
